<div class="field">
    <ng-container #fieldComponent></ng-container>
    <ng-container *ngIf="hasErrors()">
        <ng-container *ngFor="let message of errorMessages()">
            <div class="field__error">{{ message }}</div>
        </ng-container>
    </ng-container>
</div>
